export default class RpaPlatforms {
  static XERO = "xero";

  static QBO = "qbo";
}
